import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { coy } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { Tooltip } from 'antd';
import MyIcon from '@/components/MyIcon';
import '../plugin.scss';
import ToastUtils from '@/utils/ToastUtils';
const Code = (props) => {
    const { side = 'web' } = props;
    const [copySuccess, setCopySuccess] = useState(false);
    const copyCode = () => {
        const code = props.children.trim();
        navigator.clipboard.writeText(code);

        if (side === 'web') {
            setCopySuccess(true);

            setTimeout(() => {
                setCopySuccess(false);
            }, 6000);
        }
        if (side === 'mobile') {
            ToastUtils.showToast('已复制');
        }
    };
    return (
        <>
            <div className="code-block">
                <div className="code-tool">
                    <div className="language">{props.language}</div>
                    <div className="action">
                        {copySuccess ? (
                            <Tooltip title={side === 'web' ? '已复制' : null}>
                                <span style={{ color: '#52C41A' }} onClick={copyCode} className="copy">
                                    <CheckOutlined />
                                </span>
                            </Tooltip>
                        ) : (
                            <Tooltip title={side === 'web' ? '复制' : null}>
                                <span onClick={copyCode} className="copy">
                                    <MyIcon type="icon-code-copy"></MyIcon>
                                </span>
                            </Tooltip>
                        )}
                    </div>
                </div>
                <div className="code-box-wrap" data-side={side}>
                    <SyntaxHighlighter language={props.language} style={coy}>
                        {props.children}
                    </SyntaxHighlighter>
                </div>
            </div>
        </>
    );
};
export default Code;
